import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import _get from 'lodash/get'
import TileV2 from '../Tile.v2/index'
import Row, { STYLES } from '../Row.v2/index'
import RowV3 from '../Row.v3/index'
import { get as getConfig } from '../../config/index'

const config = getConfig()
const rowV3Active = !!_get(config, ['features', 'rowV3'])

function renderItem (item, params, props) {
  const { index } = params
  const {
    adminTitle,
    rowPlacement,
    sectionIndex,
    upstreamContext,
    legacyData,
    uiLocation,
  } = props

  return (
    <TileV2
      key={index}
      data={item || Map()}
      sectionIndex={sectionIndex}
      rowPlacement={rowPlacement}
      adminTitle={adminTitle}
      index={index}
      upstreamContext={upstreamContext}
      legacyData={legacyData}
      uiLocation={uiLocation}
    />
  )
}

function TileGridV2 (props) {
  const {
    tileData = List(),
    disableHover,
    reducedGrid,
  } = props

  return (
    <div className="tile-grid-v2">
      {rowV3Active
        ? <RowV3
          asGrid
          style={reducedGrid ? STYLES.S12334 : STYLES.S12345}
        >
          {(tileData || List()).map((item, index) => renderItem(item, { index }, props))}
        </RowV3>
        : <Row
          items={tileData || List()}
          createAccessor={() => null}
          style={reducedGrid ? STYLES.S12334 : STYLES.S12345}
          asGrid
          disableHover={disableHover}
        >{(item, data) => renderItem(item, data, props)}
        </Row>
      }
    </div>
  )
}

TileGridV2.propTypes = {
  tileData: ImmutablePropTypes.list.isRequired,
  upstreamContext: ImmutablePropTypes.map.isRequired,
  adminTitle: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  rowPlacement: PropTypes.number.isRequired,
  disableHover: PropTypes.bool,
  legacyData: PropTypes.bool,
  reducedGrid: PropTypes.bool,
}

TileGridV2.defaultProps = {
  tileData: List(),
  upstreamContext: Map(),
  sectionIndex: 1,
  rowPlacement: 1,
  disableHover: false,
  legacyData: true,
  reducedGrid: false,
}

export default TileGridV2
